module.exports = __webpack_public_path__ + "static/media/mix_infographic.e0eb5bc7.png";